<template>
  <div class="page">
    <div class="title-row">
      <span class="page-title">换班申请</span>
    </div>
    <div class="main-card">
      <!-- 筛选栏 -->
      <div class="filter-bar">
        <el-input v-model="query.keyword" placeholder="搜索申请人/换班人" clearable size="small" style="width:200px"></el-input>
        <el-select v-model="query.status" placeholder="审批状态" clearable size="small" style="width:140px;margin-left:8px">
          <el-option :value="0" label="待审批"></el-option>
          <el-option :value="1" label="已通过"></el-option>
          <el-option :value="2" label="已拒绝"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="fetchData" style="margin-left:8px">
          <i class="el-icon-search"></i> 查询
        </el-button>
        <el-button size="small" @click="resetQuery" style="margin-left:6px">
          <i class="el-icon-refresh"></i> 重置
        </el-button>
      </div>
      <!-- 表格 -->
      <el-table :data="tableData" v-loading="loading" :border="false" style="width:100%">
        <el-table-column label="申请人" prop="applicantName"></el-table-column>
        <el-table-column label="换班人" prop="targetStaffName"></el-table-column>
        <el-table-column label="原日期">
          <template slot-scope="{ row }">{{ fmtDate(row.originalDate) }}</template>
        </el-table-column>
        <el-table-column label="原班次" prop="originalShiftName"></el-table-column>
        <el-table-column label="目标日期">
          <template slot-scope="{ row }">{{ fmtDate(row.targetDate) }}</template>
        </el-table-column>
        <el-table-column label="目标班次" prop="targetShiftName"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="{ row }">
            <el-tag :type="statusType(row.status)" size="mini">{{ statusText(row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="申请时间">
          <template slot-scope="{ row }">{{ fmtDate(row.createdTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="{ row }">
            <template v-if="row.status === 0">
              <el-button type="text" size="mini" style="color:#10B981" @click="handleApprove(row, 1)">通过</el-button>
              <el-button type="text" size="mini" style="color:#EF4444" @click="handleApprove(row, 2)">拒绝</el-button>
            </template>
            <span v-else style="color:#94A3B8;font-size:12px">已处理</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination
          :current-page="query.pageNum"
          :page-size="query.pageSize"
          :total="total"
          layout="total, prev, pager, next"
          @current-change="onPageChange">
        </el-pagination>
      </div>
    </div>

    <!-- 审批弹窗 -->
    <el-dialog title="审批" :visible.sync="approveModalVisible" width="400px" :append-to-body="true">
      <el-form :model="approveForm" label-width="80px">
        <el-form-item label="审批备注">
          <el-input v-model="approveForm.approveRemark" type="textarea" placeholder="选填" :maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="approveModalVisible = false">取消</el-button>
        <el-button type="primary" @click="submitApprove">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSwapList, approveSwap } from './scheduleApi'
import { fmtDate } from './scheduleUtils'

export default {
  name: 'SwapApply',
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      query: { keyword: '', status: undefined, pageNum: 1, pageSize: 20 },
      approveModalVisible: false,
      approveForm: { id: 0, status: 0, approveRemark: '' }
    }
  },
  mounted() { this.fetchData() },
  methods: {
    fmtDate,
    statusText(s) { return ['待审批', '已通过', '已拒绝'][s] || '-' },
    statusType(s) { return ['warning', 'success', 'danger'][s] || 'info' },
    fetchData() {
      this.loading = true
      getSwapList({ ...this.query }).then(res => {
        if (res && res.code == 200) {
          const data = res.result || res
          this.tableData = data.list || data.records || []
          this.total = data.total || 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    resetQuery() {
      this.query.keyword = ''; this.query.status = undefined; this.query.pageNum = 1; this.fetchData()
    },
    onPageChange(page) { this.query.pageNum = page; this.fetchData() },
    handleApprove(record, status) {
      this.approveForm.id = record.id
      this.approveForm.status = status
      this.approveForm.approveRemark = ''
      this.approveModalVisible = true
    },
    async submitApprove() {
      const res = await approveSwap({ ...this.approveForm })
      if (res && res.code == 200) {
        this.$message.success('审批成功')
        this.approveModalVisible = false
        this.fetchData()
      }
    }
  }
}
</script>

<style scoped>
.page { padding: 0 16px; height: calc(100vh - 56px); display: flex; flex-direction: column; overflow: hidden; }
.title-row { display: flex; align-items: center; flex-shrink: 0; padding: 8px 0 4px; }
.page-title { font-size: 18px; font-weight: 700; color: #1E293B; }
.main-card { flex: 1; min-height: 0; background: #fff; border-radius: 10px; border: 1px solid #E2E8F0; box-shadow: 0 1px 6px rgba(0,0,0,0.04); display: flex; flex-direction: column; overflow: hidden; }
.filter-bar { display: flex; align-items: center; flex-wrap: wrap; padding: 12px 16px; border-bottom: 1px solid #F1F5F9; flex-shrink: 0; }
.pagination-wrap { display: flex; justify-content: flex-end; padding: 12px 16px; border-top: 1px solid #F1F5F9; flex-shrink: 0; }
</style>
